export default __webpack_public_path__ + "static/media/delete.0f581de0.svg";